import $ from "jquery";

$(function () {
	// If there are more colors available than the swatches shown, show the "More Colors" button
	let setupMoreColors = function () {
		$(".color-options").each(function () {
			// Ignore swatches on the PDP color selection
			if ($(this).closest(".product-option-group").length) {
				return;
			}

			// handle empty options when all variants are sold out (unlikely)
			if (!$(this).children().length) {
				return;
			}

			$(this).find(".collection-color-swatch-selection").show();
			$(this).find(".more-colors").remove();

			let containerWidth = $(this).width();
			let colorSwatchWidth =
				$(this)
					.find(".collection-color-swatch-selection")
					.first()
					.outerWidth(true) + 10; // +10 is the gap between each, formerly padding
			let maxSwatches = Math.floor(containerWidth / colorSwatchWidth);
			maxSwatches--;

			// always show 3 or 5 outside of collection pages
			let force = false;
			if (!$("body").hasClass("template-collection")) {
				force = true;
				maxSwatches = 3;
				if (
					$(window).width() >= 768 &&
					$("body").hasClass("styles-tavi")
				) {
					maxSwatches = 5;
				}
			}
			if (
				force ||
				containerWidth <
					$(this).find(".color-option-item").length * colorSwatchWidth
			) {
				// Hide swatches that don't fit
				$(this)
					.find(".color-option-item")
					.each(function (i) {
						if ($(this).closest("a").hasClass("more-colors"))
							return;
						if (i > maxSwatches - 1) {
							$(this)
								.closest(".collection-color-swatch-selection")
								.hide();
						}
					});

				// Show the "More Colors" button
				let $moreColors = $(this)
					.find(".color-option-item")
					.first()
					.closest("a")
					.clone();
				let nonVariantUrl = $moreColors
					.attr("href")
					.replace(/\?variant=[0-9]+/, "");
				$moreColors.attr("href", nonVariantUrl);
				$moreColors
					.find(".color-option-item")
					.removeAttr("title")
					.removeAttr("data-value")
					.removeAttr("data-index")
					.removeClass("selected");
				$moreColors.find(".color-swatch").remove();
				let excessColors =
					$(this).find(".color-option-item").length - maxSwatches;
				if (excessColors > 0) {
					$moreColors
						.find(".color-option-item")
						.append(
							`<span class="color-swatch excess-colors">+${excessColors}</span>`
						);
					$moreColors.addClass("more-colors");
					$(this).append($moreColors);
				}
			}
		});

		// And also trigger a click event for each selected swatch
		// to make sure the correct image and price is shown
		$(".color-option-item.selected")
			.closest(".collection-color-swatch-selection")
			.trigger("click");
	};

	// this is almost the same as collections.js. someday we should DRY these
	let colorSwatches = $(".product-item .collection-color-swatch-selection");

	colorSwatches.on("click", function (e) {
		if ($(this).hasClass("more-colors")) return true;

		e.preventDefault();

		let productContainer = $(this).closest(".product-item"),
			newUrl = $(this).attr("href"),
			imgSrc = $(this).data("image-src");

		productContainer
			.find(".collection-color-swatch-selection")
			.not($(this))
			.find(".color-option-item")
			.removeClass("selected");
		$(this).find(".color-option-item").addClass("selected");

		productContainer.find(".product-item__link").attr("href", newUrl);

		if (imgSrc.length) {
			productContainer
				.find(".product-item__image")
				.find("img")
				.attr("src", imgSrc);
		}
	});

	setupMoreColors();
	window.addEventListener("resize", (event) => {
		setupMoreColors();
	});
	$("body").on("collectionItemsAdded", setupMoreColors);
});
